// // Utility function to find a specific submenu by name
// export const findSubMenuByName = (menuData, name) => {
//     for (const menu of menuData) {
//       if (menu?.MenuItemName === name) {
//         return menu;
//       }
//       for (const subMenu of menu?.SubMenus) {
//         const result = findSubMenuByName([subMenu], name);
//         if (result) return result;
//       }
//     }
//     return null;
//   };
  // Utility function to find a specific submenu by name
export const findSubMenuByName = (menuData, name) => {
  // Ensure menuData is an array
  if (!Array.isArray(menuData)) {
    return null;
  }

  for (const menu of menuData) {
    // Check if the current menu matches the name
    if (menu?.MenuItemName === name) {
      return menu;
    }

    // If the menu has submenus, recursively search in them
    if (Array.isArray(menu?.SubMenus)) {
      for (const subMenu of menu.SubMenus) {
        const result = findSubMenuByName([subMenu], name);
        if (result) return result;
      }
    }
  }

  return null;
};
